// extracted by mini-css-extract-plugin
export default {"row":"feature-lists_row__B-dKV","background":"feature-lists_background__74N26","list":"feature-lists_list__Dn0fj","list_title":"feature-lists_list_title__zS3mQ"};